// bootstrap.js

"use strict";

import angular from "angular";
import { SWENO_ENERGIA } from "../app";

// Importar scripts externos (antes o después del bootstrap, según necesidad)
import "../assets/js/gtm.js";
import "../assets/js/analytics.js";

// Inicializar Angular
angular.bootstrap(document, [SWENO_ENERGIA.name], {
  strictDi: true
});
